import { ReactElement, ReactNode, useState } from 'react'
import { Icon } from 'components/Icon'
import { theme } from 'styles/theme/hav-theme'
import { useNavigate } from 'react-router-dom'

import * as S from './styles'

interface ItemProps {
  label: string
  icon: ReactNode
  active?: boolean
  onClick?: () => void
  route?: string
}

export interface SidebarProps {
  isCollapsed?: boolean
  children: ReactElement<ItemProps> | ReactElement<ItemProps>[]
}

export const Sidebar = ({ children, isCollapsed = false }: SidebarProps) => {
  const [collapsed, setCollapsed] = useState(isCollapsed)

  const toggleCollapse = () => {
    setCollapsed((prev) => !prev)
  }

  return (
    <S.Container collapsed={collapsed}>
      <S.ExpandWrapper>
        <S.ExpandButton onClick={toggleCollapse} collapsed={collapsed}>
          <Icon icon="arrow-forward" size="22" color={theme.colors.primary.main} />
        </S.ExpandButton>
      </S.ExpandWrapper>
      {children}
    </S.Container>
  )
}

const Item = ({ label, icon, active, route, onClick }: ItemProps) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (onClick) {
      onClick()
    } else if (route) {
      navigate(route)
    }
  }

  return (
    <S.StyledItem onClick={handleClick} active={active}>
      {icon}
      <span>{label}</span>
    </S.StyledItem>
  )
}
Sidebar.Item = Item

const Divider = () => {
  return <S.Divider />
}
Sidebar.Divider = Divider
